import AnimatedImage from 'core-lib/components/AnimatedImage';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import formatCurrency from 'core-lib/utils/currency';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { ProductCardProp } from 'src/modules/parkplusStoreV2/types/product';
import { Typography } from 'ui-v2/components/Typography';
import s from './WeekendCard.module.scss';

export const WeekendCard = (weekendCardProp: ProductCardProp) => {
  const { product, id, position, showNudge  } = weekendCardProp;

  return (
    <div className={s.root} id={id} data-index={position}>
      <ShimmerImage src={product?.coverImage} className={s.image} />

      { showNudge && (
        <div className={s.priceNudge}>
          <div className={s.tag}>
            <Typography
              label={product?.priceNudge ? product.priceNudge : product?.tag}
              color="on_dark_bg"
              variant="tiny_extended_semi_bold"
              style={{ lineHeight: '12px' }}
              lineClamp={1}
            />
          </div>
        </div>
      )}
      <div className={s.info}>
        <Typography
          label={product?.title}
          variant="label_3_medium"
          className={s.lineclamp}
        />

        <div className={s.price}>
          <Typography
            label={formatCurrency(product?.discountedPrice)}
            variant="label_3_bold"
          />
          <Typography
            label={formatCurrency(product.price)}
            variant="label_3_regular"
            className={s.lineThrough}
            color="tertiary"
          />
        </div>
        {product?.loyaltyPoints > 0 && product?.loyaltyPrice >= 0 && (
          <div className={s.mlPrice}>
            <Typography
              label={`${formatCurrency(product?.loyaltyPrice)} using `}
              variant="label_4_bold"
              color="offer"
            />
            <AnimatedImage
              src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240104160730062768.png"
              className={s.drop}
              alt="mldrop"
            />
            <Typography
              label={formatFuelBalance(product?.loyaltyPoints)}
              variant="label_4_bold"
              color="offer"
            />
          </div>
        )}
      </div>
    </div>
  );
};
